module.exports = __webpack_public_path__ + "static/Gayle Jansen-Brisbane-and-Robbie-Loya-227fa87af919ff87efcb7bdc60bc8234.jpg";